import { render, staticRenderFns } from "./FieldSources.vue?vue&type=template&id=4849f4cb"
import script from "./FieldSources.vue?vue&type=script&lang=js"
export * from "./FieldSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports